import React, {useEffect} from 'react';
import {useTheme} from "../../ProjectThemeProvider";
import {ButtonDropdown} from "../../fusion-ui";
import {getDefStr} from "../../fusion-ui/utils/ReactUtils";

/**
 * Create a theme-based button-dropdown component.
 *
 * @example
 *    const DROPDOWN_ITEMS=[
 *          item1: {
 *             name: 'Dropdown Item 1',
 *             icon: 'bi bi-app-indicator',
 *             iconRight: 'bi bi-alexa',
 *         },
 *         item2: {
 *             name: 'Dropdown Item 1',
 *             icon: 'bi bi-app-indicator',
 *             iconRight: 'bi bi-alexa',
 *         },
 *    ];
 *    <ThemedDropdownMenu
 *            className={''}
 *            buttonClassName={'border-none fw-semi-bold'}
 *            buttonHeight={'34px'}
 *            outlined={false}
 *            defOption={DROPDOWN_ITEMS.item1.name}
 *            onItemClick={(name, index) =>{
 *                console.log(name, index);
 *            }}>
 *            {Object.values(DROPDOWN_ITEMS)}
 *   </ThemedDropdownMenu>
 *
 *   //Example-2: Full implementation:
 *    <ThemedDropdownMenu
 *            className={''}
 *            itemClassName={''}
 *            buttonClassName={'border-none fw-semi-bold'}
 *            buttonHeight={'34px'}
 *            outlined={false}
 *            defOption={DROPDOWN_ITEMS.item1.name}
 *            style={{}}
 *            itemStyle={{}}
 *            itemPressStyle={{}}
 *            itemHoverStyle={{}}
 *            itemSelectedStyle={{}}
 *            buttonStyle={{}}
 *            dropdownStyle={{}}
 *            onItemClick={(name, index) =>{
 *                console.log(name, index);
 *            }}>
 *            {Object.values(DROPDOWN_ITEMS)}
 *   </ThemedDropdownMenu>
 */
const ThemedDropdownMenu = React.memo(({
                                           className = "",
                                           buttonClassName = "",
                                           itemClassName = "",
                                           textWrap = '',
                                           roundedVariant = 2,
                                           textPrefix,
                                           textPostfix,
                                           defOption,
                                           children,
                                           outlined = true,
                                           disabled,
                                           showSelectedOption = true,
                                           enableFocusStyling = false,
                                           variant = 'primary',
                                           buttonBgColor,
                                           buttonColor,
                                           buttonHoverBgColor,
                                           buttonHoverColor = 'white',
                                           itemHoverBgColor,
                                           itemSelectedBgColor,
                                           itemSelectedColor,
                                           itemHoverColor,

                                           enableRedirect = false,
                                           simpleLink = true,
                                           tooltip = '',

                                           menuItemIdKey = 'id',
                                           menuItemNameKey = 'name',
                                           menuItemLinkKey = 'link',
                                           dividerKey = 'divider',
                                           highlightableKey = 'highlightable',

                                           buttonHeight = '34px',
                                           onItemClick,
                                           onExpand,

                                           style = {},
                                           itemStyle = {},
                                           itemHoverStyle = {},
                                           itemPressStyle = {},
                                           itemSelectedStyle = {},
                                           buttonStyle = {},
                                           buttonHoverStyle = {},
                                           buttonTouchStyle = {},
                                           dropdownStyle = {},
                                           ...rest
                                       }) => {
    const TAG = "ThemedDropdownMenu";

    const theme = useTheme();

    useEffect(() => {
        // console.log(TAG, 'children:', children)
    }, [children]);

    return (<>
            <ButtonDropdown
                className={`${className}`}
                buttonClassName={`border-nonex highlight-theme-full-hoverx text-white-hoverx fs-sm px-2 py-1 ${buttonClassName} rounded-${roundedVariant}`}
                itemClassName={`${itemClassName}`}
                buttonStyle={{
                    height: buttonHeight,
                    color: getDefStr(buttonColor, theme[variant]),
                    backgroundColor: getDefStr(buttonBgColor, theme[variant + '10']),
                    ...buttonStyle
                }}
                buttonHoverStyle={{
                    color: buttonHoverColor,
                    backgroundColor: getDefStr(buttonHoverBgColor, theme[variant]),
                    ...buttonHoverStyle
                }}
                buttonTouchStyle={{
                    color: buttonHoverColor,
                    backgroundColor: getDefStr(buttonHoverBgColor, theme[variant]),
                    ...buttonHoverStyle
                }}
                style={style}
                disabled={disabled}
                variant={'x'}
                buttonVariant={'x'}
                selectedItemBgVariant={'x'}
                selectedItemColorVariant={'x'}
                outlined={outlined}
                enableFocusStyling={enableFocusStyling}
                textPrefix={textPrefix}
                textPostfix={textPostfix}
                textWrap={textWrap}
                defOption={defOption}
                showSelectedOption={showSelectedOption}
                menuItemIdKey={menuItemIdKey}
                menuItemNameKey={menuItemNameKey}
                menuItemLinkKey={menuItemLinkKey}
                dividerKey={dividerKey}
                highlightableKey={highlightableKey}
                simpleLink={simpleLink}
                enableRedirect={enableRedirect}
                tooltip={tooltip}
                onExpand={onExpand}
                onMenuItemClick={(name, index, item) => {
                    if (onItemClick) onItemClick(name, index, item);
                }}
                rippleColor={theme.rippleColorXl}
                dropdownStyle={{
                    ...theme.dropdownMenuStyle,
                    ...dropdownStyle,
                }}
                itemStyle={{
                    ...itemStyle
                }}
                itemHoverStyle={{
                    color: getDefStr(itemHoverColor, theme[variant]),
                    backgroundColor: getDefStr(itemHoverBgColor, theme[`${variant}20`]),
                    ...itemHoverStyle
                }}
                itemSelectedStyle={{
                    color: getDefStr(itemSelectedColor, theme.textWhite),
                    backgroundColor: getDefStr(itemSelectedBgColor, theme[variant]),
                    fontWeight: 600,
                    ...itemSelectedStyle
                }}
                itemPressStyle={{
                    ...itemPressStyle
                }}
                {...rest}
            >
                {children}
            </ButtonDropdown>
        </>
    )

    function fun() {

    }
});
export default ThemedDropdownMenu;
